module.exports = __webpack_public_path__ + "img/f2bef26.webp";